import React, { useState } from 'react';
import { Typography } from '@mui/material';
import TextField from 'components/Common/TextField';
import Grid from '@mui/material/Grid';
import IndustryDropDown from 'components/Common/IndustryAutoComplete';
import MaskField from 'components/Common/MaskField'

const DetailSection = ({ onchange, data, errors }) => {
    const [erros, setErrors] = useState({
        yearEstablished: false
    });
    const handleInput = (e) => {
        const { name, value } = e.target;
        onchange({ [name]: value })
    }

    const handleKeyPress = e => {
        var regex = new RegExp('^[0-9]+$')
        var key = String.fromCharCode(!e.charCode ? e.which : e.charCode)
        if (!regex.test(key)) {
            e.preventDefault()
            return false
        }
    }
    const checkError = (e) => {
        const { name, value } = e.target;
        if (name === 'yearEstablished') {
            const isValidYear = /^\d{4}$/.test(value.toString())
            const currentYear = new Date().getFullYear()
            if (!isValidYear || (value > currentYear)) {
                setErrors({
                    ...erros,
                    [name]: true
                })
            } else {
                setErrors({
                    ...erros,
                    [name]: false
                })
            }
        }
    }

    return (
        <>
            <Typography variant='h6' className='my-5' style={{ color: '#25245F' }}>Business Details</Typography>
            <Grid container spacing={2}>
                <Grid item xs={12} md={3}>
                    <TextField
                        required
                        InputLabelProps={{ shrink: false }}
                        label="Business Name (DBA)"
                        size="small"
                        name='businessName'
                        value={data.businessName}
                        error={false}
                        fullWidth
                        bgwhite
                        onChange={handleInput}
                    />
                </Grid>
                <Grid item xs={12} md={3}>
                    <MaskField
                        name='businessPhone'
                        isMasked
                        maskPatten="000-000-0000"
                        required
                        fullWidth
                        label="Business Phone Number"
                        bgwhite
                        zeroMarginLabel
                        onChange={val => handleInput({
                            target: {
                                name: 'businessPhone',
                                value: (val.value).split('-').join('')
                            }
                        })}
                        error={errors?.businessPhone ? true : false}
                        helperText={errors?.businessPhone || ''}
                    />
                </Grid>
                <Grid item xs={12} md={3}>
                    <TextField
                        type='text' className='hiddenArrow-input'
                        InputLabelProps={{ shrink: false }}
                        label="Year Established"
                        name='yearEstablished'
                        value={data.yearEstablished}
                        size="small"
                        fullWidth
                        bgwhite
                        required
                        error={erros.yearEstablished}
                        onChange={handleInput}
                        onBlur={checkError}
                        onKeyPress={handleKeyPress}
                        inputProps={{ maxLength: '4' }}
                        helperText={<Typography variant='subtitle2'>{erros.yearEstablished && 'Please enter valid year.'}</Typography>}
                    />
                </Grid>
                <Grid item xs={12} md={3}>
                    <IndustryDropDown bgwhite handleValue={(val) => handleInput({
                        target: {
                            name: val.name,
                            value: val.value
                        }
                    })} defaultValue={data.industry} />
                </Grid>
                <Grid item xs={12} md={3}>
                    <TextField
                        InputLabelProps={{ shrink: false }}
                        label="Website URL"
                        size="small"
                        fullWidth
                        name='website'
                        bgwhite
                        value={data.website}
                        onChange={handleInput}
                    />
                </Grid>
                <Grid item xs={12} md={3}>
                    <TextField
                        InputLabelProps={{ shrink: false }}
                        label="Legal Business Name"
                        size="small"
                        fullWidth
                        bgwhite
                        name='legalBusinessName'
                        value={data.legalBusinessName}
                        onChange={handleInput}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField
                        InputLabelProps={{ shrink: false }}
                        label="Company Description"
                        size="small"
                        name='description'
                        value={data.description}
                        fullWidth
                        bgwhite
                        onChange={handleInput}
                    />
                </Grid>
            </Grid>
        </>
    )
}

export default DetailSection;